import Accordion from '../../Accordion';

const content = (
  <div>
    <p>
      Your earnings are calculated by comparing your actual battery behaviour (managed by Loop Optimise) against how a
      standard, non-optimised battery would have performed.
    </p>
    <p>Loop Optimise tells your battery to:</p>
    <ul>
      <li>Charge from the grid when electricity is cheap</li>
      <li>Use energy from the battery when electricity is expensive</li>
      <li>Export to the grid when export prices are high</li>
    </ul>
    <p>
      The difference between your actual financial outcome and the non-optimised baseline is your Loop Optimise saving.
    </p>
  </div>
);

const EarningsAccordion = () => <Accordion data={[{ title: 'How we have calculated your earnings', content }]} />;

export default EarningsAccordion;
